import { Action } from '@/_core/fluxstore/types';
import { snackbar } from '@/_core/app-components/use';
import { DeleteCardResult } from '../../../api/commands';
import { createPermanentDeleteFromTrashCommand } from '../../../api/commands/factory/createPermanentDeleteFromTrashCommand';
import { TrashOperationResultCode } from '../../../api/queries';
import { StorymapState, TrashRow } from '../../types';
import { useStorymapStore } from '../../useModule';
import { sendTrashCommand } from './sendTrashCommand';

const { registerMiddleware, registerReducer } = useStorymapStore();

export class PermanentlyDeleteCardFromTrash extends Action<StorymapState> {
    public static ACTION_TYPE = 'PermanentlyDeleteCardFromTrash';

    public constructor(public row: TrashRow) {
        super(PermanentlyDeleteCardFromTrash.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: PermanentlyDeleteCardFromTrash): Promise<boolean> => {
    if (!action.row || state.trashState.isLoading || state.trashState.isRowOperationInProgress) {
        return true;
    }

    const token = state.trashState.rowOperationToken + 1;
    state.trashState.rowOperationToken = token;
    state.trashState.isRowOperationInProgress = true;

    try {
        const result = await sendTrashCommand<DeleteCardResult>(await createPermanentDeleteFromTrashCommand(action));

        if (result?.IsSuccess || isStaleCode(result?.ResultCode)) {
            if (state.trashState.isDialogOpen && state.trashState.rowOperationToken === token) {
                state.trashState.rows = state.trashState.rows.filter((x) => x.id !== action.row.id);
                state.trashState.selectedRowId = null;
            }
            snackbar.showSuccess(result?.IsSuccess ? 'Card permanently deleted.' : 'The selected row is no longer in trash.');
            return true;
        }

        snackbar.showError(result?.Message || 'Permanent delete failed. Please try again.');
        return true;
    } finally {
        if (state.trashState.isDialogOpen && state.trashState.rowOperationToken === token) {
            state.trashState.isRowOperationInProgress = false;
        }
    }
};

const reducer = (): void => {
    // State is updated in middleware because command result variants drive different transitions.
};

const isStaleCode = (resultCode: TrashOperationResultCode): boolean =>
    resultCode === TrashOperationResultCode.AlreadyRestored ||
    resultCode === TrashOperationResultCode.AlreadyPermanentlyDeleted ||
    resultCode === TrashOperationResultCode.NoLongerDirectlyTrashed;

//@ts-ignore
registerMiddleware(PermanentlyDeleteCardFromTrash.ACTION_TYPE, middleware);
//@ts-ignore
registerReducer(PermanentlyDeleteCardFromTrash.ACTION_TYPE, reducer);
